import { UserService } from '@services/user/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { SettingService } from '@services/setting/setting.service';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { environment } from 'environments/environment';
import { Label } from 'ng2-charts';
import { LoadingService } from '@services/loading/loading.service';
import { Router } from '@angular/router';
import { WebSocketService } from '@services/websocket/websocket.service';
import { AuthService } from '@services/auth/auth.service';
import { TitleService } from '@services/title.service';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent {
  public env = environment.forntend_url;
  public today: Date = new Date();

  // Doughnut
  public doughnutChartLabels: Label[] = [
    'Product 1',
    'Product 2',
    'Product 3',
    'Product 4',
  ];
  public doughnutChartData: ChartDataSets[] = [
    {
      data: [900, 400, 500, 300],
      backgroundColor: ['#FF8373', '#55D8FE', '#FFDA83', '#A3A0FB'],
    },
  ];
  public doughnutChartType: ChartType = 'doughnut';

  // Bar
  public barChartType: ChartType = 'bar';
  public barChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: true,
    scales: { xAxes: [{}], yAxes: [{}] },
  };
  public barChartLabels: Label[] = ['Aug', 'Jun', 'May', 'Sep'];
  public barChartLegend = true;
  public barChartData: ChartDataSets[] = [
    {
      data: [4, 5, 10, 15],
      label: 'Jeddah',
      borderColor: '#A4A1FB',
      backgroundColor: '#A4A1FB',
    },
    {
      data: [2, 1, 6, 12],
      label: 'Riyadh',
      borderColor: '#56D9FE',
      backgroundColor: '#56D9FE',
    },
    {
      data: [2, 2, 6, 12],
      label: 'Dammam',
      borderColor: '#5FE3A1',
      backgroundColor: '#5FE3A1',
    },
  ];

  public loading: boolean = false;

  constructor(
    public settingService: SettingService,
    public webSocket: WebSocketService,
    public loader: LoadingService,
    public router: Router,
    private _userService: UserService,
    public authService: AuthService,
    private titleService: TitleService
  ) {
    this.titleService.setTitle();

    let get_user = JSON.parse(localStorage.getItem('user'));
    let user_id = get_user['data']['user_id'];

    this.settingService.userRolePermissionList(user_id).subscribe(
      (res) => {
        let data = res['data'];
      },
      (error: HttpErrorResponse) => {
        if (error.error.message == 'The incoming token has expired') {
          this.router.navigate(['/']);
        }
      }
    );
    this.GetWinnerList();
  }

  ngOnInit() {}

  ngOnDestroy() {}

  winnerList: any[] = [];
  GetWinnerList() {
    this._userService.getWinnerList().subscribe((res) => {
      this.winnerList = res['data'];
    });
  }
}
